import React from "react";

export const PilotView = ({pilot}) =>
  <span className={'pilotView'}>
    {pilot &&
    <span><strong>{pilot.surname}</strong> <span className={'small'}>{pilot.name}</span></span>
    }
  </span>